import { useEffect, useState } from 'react';
import Raven from 'raven-js';
import { getAbsoluteReconnectUrl } from '../../utils/urlUtils';
import { BasicReconnectButton } from '../../components/reconnectButton/BasicReconnectButton';
import * as TrelloApi from './TrelloApi';
import { jsx as _jsx } from "react/jsx-runtime";
const FIVE_MINUTES = 300000;
export const TrelloReconnectButton = ({
  buttonProps,
  buttonComponent,
  loading: propsLoading,
  failed: propsFailed,
  'data-test-id': dataTestId,
  label,
  metadata,
  onAuthStarted,
  onAuthCancelled,
  onAuthSucceeded,
  timeout = FIVE_MINUTES,
  url
}) => {
  const [loading, setLoading] = useState(false);
  const [redirectUrlLoading, setRedirectUrlLoading] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState(undefined);
  const [error, setError] = useState(null);
  const appId = metadata === null || metadata === void 0 ? void 0 : metadata.appId;
  const accountId = metadata === null || metadata === void 0 ? void 0 : metadata.accountId;
  const authUrl = getAbsoluteReconnectUrl({
    urlTemplate: redirectUrl !== null && redirectUrl !== void 0 ? redirectUrl : url,
    appId,
    accountId
  });
  const handleAuthSucceeded = code => {
    setLoading(true);
    TrelloApi.installTrello(code).then(() => {
      setError(null);
      onAuthSucceeded === null || onAuthSucceeded === void 0 || onAuthSucceeded(code);
    }).catch(err => {
      Raven.captureException(err, {
        extra: {
          message: 'Error on authentication of Trello'
        }
      });
      setError(err);
    }).finally(() => {
      setLoading(false);
    });
  };
  const updatedButtonProps = Object.assign({}, buttonProps || {}, {
    disabled: (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.disabled) || redirectUrlLoading
  });
  const isLoading = propsLoading || loading;
  const isFailed = propsFailed || !!error;
  useEffect(() => {
    setRedirectUrlLoading(true);
    TrelloApi.startOAuth().then(response => {
      setRedirectUrl(response.redirectUrl);
    }).catch(err => {
      Raven.captureException(err, {
        extra: {
          message: 'Error on starting OAuth for Trello'
        }
      });
      setError(err);
    }).finally(() => {
      setRedirectUrlLoading(false);
    });
  }, []);
  return authUrl && label ? /*#__PURE__*/_jsx(BasicReconnectButton, {
    buttonProps: updatedButtonProps,
    buttonComponent: buttonComponent,
    loading: isLoading,
    failed: isFailed,
    "data-test-id": dataTestId,
    label: label,
    onAuthStarted: onAuthStarted,
    onAuthCancelled: onAuthCancelled,
    onAuthSucceeded: handleAuthSucceeded,
    timeout: timeout,
    url: authUrl
  }) : null;
};